import { z } from 'zod';

export const PaginationQuerySchema = z.object({
  limit: z
    .preprocess(
      (val) => (val === undefined ? 10 : Number(val)),
      z.number().int().min(1, 'Limit must be a positive integer'),
    )
    .optional()
    .default(10),
  page: z
    .preprocess(
      (val) => (val === undefined ? 0 : Number(val)),
      z.number().int().min(0, 'Page must be a non-negative integer'),
    )
    .optional()
    .default(0),
});

export type IPaginationQueryDto = z.infer<typeof PaginationQuerySchema>;

export type IPaginatedResponseDto<T> = {
  data: T[];
  meta: {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
};
